import TermsView from "./view";
import { useNavigate } from "react-router-dom";

export default function Terms() {
  const navigate = useNavigate();

  const goBack = () => navigate(-1);

  return (
    <TermsView
      goBack={goBack}
    />
  );
}